import { Avatar, AvatarSize, Box, Icon, IconSize, Text } from '@bechtel/gds';
import { CrewMember } from '@bechtel/types';
import React, { FC } from 'react';
import { Trans } from '@lingui/macro';
import { useName, PersonaMessages } from '@bechtel/client-common';

export const UserSelectItem: FC<CrewMember> = ({ imageUrl, firstName, lastName, persona }) => {
  const { getFullName } = useName();
  return (
    <Box alignItems={{ sm: 'center' }} px={{ sm: '100' }}>
      <Box mr={{ sm: '400' }}>
        {imageUrl ? (
          <Avatar
            size={AvatarSize.MEDIUM}
            src={imageUrl ?? ''}
            style={{ borderWidth: '0px' }}
            data-testid="work-owner-photo"
          />
        ) : (
          <Box
            mr={{ sm: '100' }}
            p={{ sm: '300' }}
            css={`
              background-color: ${({ theme }) => theme.colors.grey[300]};
              border-radius: ${({ theme }) => theme.radii[900]};
            `}
          >
            <Icon icon="user" fillColor="white" size={IconSize.MEDIUM} iconStyle="solid"></Icon>
          </Box>
        )}
      </Box>

      <Box flexDirection={{ sm: 'column' }}>
        <Box mb={{ sm: '300' }}>
          <Text size="400" weight="600" color="grey.1000" data-testid="work-owner-name">
            {getFullName(firstName, lastName)}
          </Text>
        </Box>
        <Text size="300" color="grey.600" data-testid="work-owner-title" transform="capitalize">
          {persona ? <Trans id={PersonaMessages[persona].id}></Trans> : ''}
        </Text>
      </Box>
    </Box>
  );
};
